import tw, { styled, css } from "twin.macro";

export const Wrapper = styled.div`
	${tw`p-4 h-full pb-0 relative`}
`;

export const active = (props) => css`
	${tw`shadow rounded-2xl min-w-min text-white bg-appPink inline-flex gap-2 items-center justify-center py-4 text-base hover:(bg-appPinkSaturated text-white) active:(bg-appPink text-white border-none) focus:(bg-appPink text-white border-none)`}
	font-family: Poppins;
	line-height: 12px;
	letter-spacing: 0.5px;
`;
export const inactive = (props) => css`
	${tw`text-appTextFaded! font-medium shadow  rounded-2xl min-w-min text-white bg-appGentleGray inline-flex gap-2 text-base items-center justify-center py-4 hover:(bg-appPinkSaturated text-white) active:(bg-appPink text-white border-none) focus:(bg-appPink text-white border-none)`}
	font-family: Poppins;
	line-height: 12px;
	letter-spacing: 0.5px;
`;